export const ConnectionInitiated = "ConnectionInitiated"
export const AgentRepliesText = "AgentRepliesText"
export const ChatRoomInitiated = "ChatRoomInitiated"
export const MessageCreated = "MessageCreated"
export const SystemClosedTheChat = "SystemClosedTheChat"
export const ValidateStaleConversationIdResult = "ValidateStaleConversationIdResult"
export const MessageWithMediaCreated = 'MessageWithMediaCreated'
export const AgentRepliesMedia = 'AgentRepliesMedia'
export const SendMediaError = 'SendMediaError'
export const CaptchaChallengeAnswerError = 'CaptchaChallengeAnswerError'
export const AgentIsAssignedToChat = 'AgentIsAssignedToChat'
export const CustomerSeemsInactive = 'CustomerSeemsInactive'
export const CustomerClosesTheChatDueToInactivity = 'CustomerClosesTheChatDueToInactivity'
export const FailedToInitiateChatRoom = 'FailedToInitiateChatRoom'
export const PingFromServer = 'Ping'

export function parse(raw) {
    const { type, message, connectionId } = raw
    if(type == PingFromServer) {
        return {
            type: PingFromServer,
            ts: message.ts
        }
    }
    if (type == CustomerSeemsInactive) {
        return {
            type: CustomerSeemsInactive,
            text: message.message
        }
    }
    if (type == CustomerClosesTheChatDueToInactivity) {
        return {
            type: CustomerClosesTheChatDueToInactivity,
            text: message.message
        }
    }
    if (type == AgentIsAssignedToChat) {
        return {
            type: AgentIsAssignedToChat,
            agentName: message.agentName
        }
    }
    if (type == CaptchaChallengeAnswerError) {
        return {
            type: CaptchaChallengeAnswerError,
            message: message.message
        }
    }
    if (type == ConnectionInitiated) {
        return {
            type: ConnectionInitiated,
            connectionId: message.connectionId
        }
    }
    if (type == AgentRepliesText) {
        return {
            type: AgentRepliesText,
            messageId: message.messageId,
            text: message.text,
            agentName: message.agentName,
            timestamp: message.timestamp,
            serverSideId: message.serverSideId
        }
    }
    if (type == ChatRoomInitiated) {
        return {
            type: ChatRoomInitiated,
            chatRoomId: message.chatRoomId,
            customer: message.customer
        }
    }
    if (type == MessageCreated) {
        return {
            type: MessageCreated,
            messageId: message.messageId,
            text: message.text,
            timestamp: message.timestamp,
            clientSideId: message.clientSideId
        }
    }
    if (type == SystemClosedTheChat) {
        return {
            type: SystemClosedTheChat,
            conversationId: message.conversationId
        }
    }
    if (type == ValidateStaleConversationIdResult) {
        return {
            type: ValidateStaleConversationIdResult,
            isValid: message.isValid,
            conversationId: message.conversationId,
            assignedAgent: message.assignedAgent,
            customer: message.customer
        }
    }
    if (type == MessageWithMediaCreated) {
        return {
            type: MessageWithMediaCreated,
            messageId: message.messageId,
            text: message.text,
            timestamp: message.timestamp,
            mediaList: message.mediaList,
            clientSideId: message.clientSideId
        }
    }
    if (type == AgentRepliesMedia) {
        return {
            type: AgentRepliesMedia,
            messageId: message.messageId,
            mediaList: [message.media],
            agentName: message.agentName,
            timestamp: message.timestamp,
            text: '',
            serverSideId: message.serverSideId
        }
    }
    if (type == SendMediaError) {
        return {
            type: SendMediaError,
            content: message.content,
            mediaList: [message.media]
        }
    }
    if (type == FailedToInitiateChatRoom) {
        return {
            type: FailedToInitiateChatRoom,
            reason: message.reason
        }
    }
}